// import { useQuery } from "react-query";

// const FetchQuery = () => {
//   const { isLoading, error, data } = useQuery("repoData", () =>

//   );
//   if (isLoading) return "Loading...";

//   if (error) return "An error has occurred: " + error.message;
//   return data;
// };
import storageFactory from './localstoragehelper';

export const localStore = storageFactory(() => localStorage);
export const sessionStore = storageFactory(() => sessionStorage);
export const fetchData = () =>
  fetch('https://jsonplaceholder.typicode.com/todos/1').then((res) =>
    res.json()
  );



// WEBPACK FOOTER //
// ./src/helpers/index.js